import userApi from 'apis/userApi';
import { RootState, useAppSelector } from 'cache/store';
import { colors } from 'constants/theme';
import DatePicker from 'components/date-picker/DatePicker';
import LoadingIcon from 'components/loading/LoadingIcon';
import Modal from 'components/modal/Modal';
import globalStyle from 'constants/global.style';
import { NewListStastRespone } from 'models/statisticModel';
import moment from 'moment';
import { useState } from 'react';
import toast from 'react-hot-toast';
import StatsAgencyDetail from './StatsAgencyDetail';
import accountStyles from './account-option.style';
import { css } from '@emotion/css';

const actionType = [
    { value: 0, label: 'Đặt cược từ lớn tới nhỏ' },
    { value: 1, label: 'Chiết khấu từ lớn tới nhỏ' },
    { value: 2, label: 'Trúng cược từ lớn tới nhỏ' },
    { value: 3, label: 'Khuyến mãi từ lớn tới nhỏ' },
    { value: 4, label: 'Nạp tiền từ lớn tới nhỏ' },
    { value: 5, label: 'Rút tiền từ lớn tới nhỏ' },
];

function StatsAgency() {
    const { agentType } = useAppSelector((state: RootState) => state.auth);

    const [startTime, setStartTime] = useState<Date | null>(new Date(`${moment(new Date()).format('yyyy-MM-DD')}`));
    const [endTime, setEndTime] = useState<Date | null>(new Date(`${moment(new Date()).format('yyyy-MM-DD')}`));
    const [orderSelect, setOrderSelect] = useState(0);
    const [loginname, setLoginName] = useState('');
    const [recordList, setRecordList] = useState<NewListStastRespone[] | null>(null);
    const [mainRecord, setMainRecord] = useState<NewListStastRespone | null>(null);
    const [totalRecord, setTotalRecord] = useState<NewListStastRespone | null>(null);
    const [loading, setLoading] = useState(false);

    const [recordDetail, setRecordDetail] = useState<any>(null);

    const searchStats = async () => {
        if (!startTime || !endTime) {
            toast.error('Ngày chọn không hợp lệ');
            return;
        }
        setLoading(true);
        const payload = {
            order: orderSelect,
            loginname,
            stime: moment(startTime).format('yyyy-MM-DD'),
            etime: moment(endTime).format('yyyy-MM-DD'),
        };
        try {
            const { data } = await userApi.reportWinLossSearch(payload);
            if (!data.msg) {
                setRecordList(data.reportmain);
                setMainRecord(data.ruitem);
                setTotalRecord(data.totallist);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <div className={`${styles.wrap}`}>
                <div className={styles.containerBox}>
                    <div className={styles.itemBox}>
                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Thời Gian Từ</label>
                            <div className={styles.wrapInput}>
                                <DatePicker dateSelect={startTime} onSelectDate={(date) => setStartTime(date)} noneStyle maxDate={new Date()} />
                            </div>
                        </div>

                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Loại</label>
                            <div className={styles.wrapInput}>
                                <select value={orderSelect} onChange={(e) => setOrderSelect(Number(e.target.value))}>
                                    {actionType.map((item) => (
                                        <option value={item.value} key={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className={styles.itemBox}>
                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Đến</label>
                            <div className={styles.wrapInput}>
                                <DatePicker dateSelect={endTime} onSelectDate={(date) => setEndTime(date)} noneStyle maxDate={new Date()} />
                            </div>
                        </div>
                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Tên Tài Khoản</label>
                            <div className={styles.wrapInput}>
                                <input value={loginname} onChange={(e) => setLoginName(e.target.value)} type="text" />
                            </div>
                        </div>
                    </div>

                    <div className={styles.itemBox}>
                        <div />
                        <button type="button" className={styles.btnSubmit} onClick={searchStats}>
                            Tìm Kiếm
                        </button>
                    </div>
                </div>

                <div className={styles.containerTable}>
                    <div className={styles.table}>
                        <div className="row">
                            <div className={`title col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>Hội viên</div>
                            <div className={`title col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>Nạp tiền</div>
                            <div className={`title col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>Rút tiền</div>
                            {agentType === 1 && (
                                <>
                                    <div className={`title col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>Nạp tiền cấp dưới</div>
                                    <div className={`title col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>Rút tiền cấp dưới</div>
                                </>
                            )}
                            <div className={`title col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>Cược</div>
                            <div className={`title col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>Chiết khấu</div>
                            <div className={`title col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>Trúng</div>
                            <div className={`title col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>Khuyến mãi</div>
                            <div className={`title col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>Lợi nhuận</div>
                            <div className={`title col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>Xem</div>
                        </div>
                        {recordList ? (
                            <>
                                {mainRecord && (
                                    <div className="row">
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{mainRecord.loginname}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(mainRecord.dp)}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(mainRecord.wd + mainRecord.adjmoney)}</p>
                                        {agentType === 1 && (
                                            <>
                                                <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(mainRecord.sjdp)}</p>
                                                <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(mainRecord.wdagent)}</p>
                                            </>
                                        )}
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(mainRecord.tz)}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(mainRecord.fd)}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(mainRecord.win)}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(mainRecord.bonus)}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)} ${mainRecord.saletz >= 0 ? 'text-success' : 'text-error'}`}>
                                            {new Intl.NumberFormat().format(mainRecord.saletz)}
                                        </p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}></p>
                                    </div>
                                )}
                                {recordList.map((item, index) => (
                                    <div className="row" key={index}>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{item.loginname}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(item.dp)}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(item.wd + item.adjmoney)}</p>
                                        {agentType === 1 && (
                                            <>
                                                <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(item.dpxj)}</p>
                                                <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(item.wdchild)}</p>
                                            </>
                                        )}
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(item.tz)}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(item.fd)}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(item.win)}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(item.bonus)}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)} ${item.saletz >= 0 ? 'text-success' : 'text-error'}`}>
                                            {new Intl.NumberFormat().format(item.saletz)}
                                        </p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>
                                            <span className="btn-detail" onClick={() => setRecordDetail(item)}>
                                                Chi tiết
                                            </span>
                                        </p>
                                    </div>
                                ))}

                                {totalRecord && (
                                    <div className="row">
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>Tổng cộng</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(totalRecord.dp)}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(totalRecord.wd + totalRecord.adjmoney)}</p>
                                        {agentType === 1 && (
                                            <>
                                                <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(totalRecord.sjdp)}</p>
                                                <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(totalRecord.wdagent)}</p>
                                            </>
                                        )}
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(totalRecord.tz)}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(totalRecord.fd)}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(totalRecord.win)}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}>{new Intl.NumberFormat().format(totalRecord.bonus)}</p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)} ${totalRecord.saletz >= 0 ? 'text-success' : 'text-error'}`}>
                                            {new Intl.NumberFormat().format(totalRecord.saletz)}
                                        </p>
                                        <p className={`col ${globalStyle.flexItems(agentType === 1 ? 11 : 9)}`}></p>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div className="no-data"></div>
                        )}
                    </div>
                </div>
            </div>
            <Modal isShow={Boolean(recordDetail)} onClose={() => setRecordDetail(null)} closeClickBackdrop>
                <StatsAgencyDetail statsData={recordDetail} onClose={() => setRecordDetail(null)} />
            </Modal>
            {loading && <LoadingIcon />}
        </>
    );
}

export default StatsAgency;

const styles = {
    btnSubmit: css`
        background: #ffad33 !important;
        border-radius: 3px !important;
        border: 1px solid #c9820a !important;
        color: white;
        padding-top: 10px;
        padding-bottom: 10px;
        width: 130px;
        margin-bottom: 20px;
    `,
    wrap: css`
        color: black;
        background-color: white;
        border-radius: 8px;
        padding: 20px;
    `,
    containerBox: css`
        background-color: #f9f9f9;
        padding: 15px 40px 8px;
        border-radius: 3px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
        margin-bottom: 15px;
        border-left: 3px solid #ebc85e;
        display: flex;
        gap: 40px;
    `,
    itemBox: css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        label {
            font-weight: 300;
            font-size: 17px;
            width: 100%;
        }
    `,
    wrapInput: css`
        color: black;
        display: flex;
        flex: 1;
        width: 300px;
        input {
            border: none;
            height: 40px;
            border-bottom: 1px solid black;
            padding-left: 10px;
            background-color: white;
            width: 100%;
        }
        select {
            border: none;
            background-color: white;
            height: 40px;
            border-bottom: 1px solid black;
            width: 100%;
            color: black;
            box-shadow: none;
            outline: none;
            padding-left: 5px;
            &:focus {
                border: none;
                box-shadow: none;
            }
        }
    `,
    containerTable: css`
        background-color: #f2f2f2;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
        min-height: 250px;
        border-radius: 5px;
        padding: 4px 4px 18px;
        margin-bottom: 100px;
    `,
    table: css`
        border-radius: 5px;
        overflow: hidden;
        &.table-col-center {
            .col {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        .row {
            display: flex;
            border-bottom: 1px solid var(--border-table);
            background-color: #e2dfdc;
            &:first-child {
                border-bottom-color: white;
            }
            &:last-child {
                border-bottom: none;
            }
        }
        .col {
            flex: 1;
            padding: 12px 8px;
            text-align: center;
            font-size: 12.8px;
            font-weight: 300;
        }
        .text-left {
            text-align: left;
        }
        .title {
            color: white;
            font-weight: 300;
            border-right: 1px solid white;
            background-color: ${colors.primary};
            &:last-child {
                border-right: 0;
            }
        }
        .no-data {
            text-align: center;
            padding: 30px;
            height: 180px;
            p {
                margin-top: 8px;
                font-size: 14px;
            }
        }
    `,
};
